import { DomainRegistry } from "../DomainRegistry";
import { IConfiguration } from "../configuration";
import { Patient } from "../patient";
import { User } from "../user";
import { WindowOpener } from "../../components/system/utilities";

export class ClaioViewerLauncher {
  constructor(private _configuration: IConfiguration) {
  }
  
  public async launch(user: User, patient: Patient, imageId: string, imageDepartmentId: string, isMovie: boolean, documentDepartmentId: string): Promise<void> {
    if (this._configuration.behavior.document.editor.contents.claio.imageViewer.application === "claioImageView") {
      this.openClaioImageView(patient, imageId, documentDepartmentId);
    } else {
      await this.launchClaioApplication(user, patient, imageId, imageDepartmentId, isMovie, documentDepartmentId);
    }
  }

  private openClaioImageView(patient: Patient, imageId: string, documentDepartmentId: string): void {
    // 位置記憶でサイズ復帰してもらう想定
    // WindowOpener経由だと現在のウィンドウとほぼ同じサイズで子ウィンドウを開こうとするため、直接開いている
    const location = "/ShowClaioImage?" + this.createClaioImageViewParameter(patient, imageId, documentDepartmentId);
    window.open(WindowOpener.toUrl(location, {}), "", this._configuration.system.window.opener.features);
  }

  private createClaioImageViewParameter(patient: Patient, imageId: string, documentDepartmentId: string): string {
    const parameters: string[] = [];
    parameters.push("patientNo=" + patient.id);
    parameters.push("claioImageId=" + imageId);
    if (documentDepartmentId) {
      parameters.push("documentDepartmentCode=" + documentDepartmentId);
    }
    return parameters.join("&");
  }

  public async launchClaioApplication(user: User, patient: Patient, imageId: string, imageDepartmentId: string, isMovie: boolean, documentDepartmentId: string): Promise<void> {
    // クライオ起動時の診療科は設定によって変わる。
    // ini設定 Claio診療科指定方法：CLAIO_MEDICAL_DEPT 1:DM主科(デフォルト) 2:画像診療科
    // 徳大では画像診療科に設定されているため画像に紐づく診療科で起動する
    // TODO: 設定による診療科の指定の切り替え
    const service = DomainRegistry.localhost.getApplicationService();
    const departmentId = !!imageDepartmentId ? imageDepartmentId : documentDepartmentId;
    return service.launchClaio(user, patient, departmentId, imageId, isMovie);
  }
}
